<template>      
<div key=9>    


          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="h5 text-muted">Build</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1" class="small mb-0">Select a Build<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
                  <v-select 
                    v-model="build_sel"
                    placeholder="Select a Build"
                    label="build_name"
                    :options= "userBuildList"
                    :reduce="userBuildList => userBuildList.id"
                    class="p-0 bg-white style-chooser">
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button v-if="build_sel != ''" class="btn btn-primary" @click="selectOnly">Use this Build</button>
                <button v-if="prop1 == 1" class="btn btn-danger" @click="cancel">Cancel</button>
              </div>
            </div>
          </div>

          
</div>
</template>


<script>
import {store} from '../../../stores/quote-builder-main-store.js'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      build_sel: '',
    }
  },
  computed: {
    userBuildList () { return this.$store.state.userBuildList },
    
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    cancel() {
      var _this = this;
      _this.$emit('onBuildUComplete', [ 'build-chooser', '', ''])
    },
    selectOnly() {
      var _this = this;
      if(_this.build_sel == '' | _this.build_sel == null) {
        return false;
      } else {
        _this.$emit('onBuildSComplete', [ 'build-chooser', _this.build_sel ])
      }
      
    },
  },    
  components:{

  },
  filters: {

  }
}
</script>
